import { useQsFilters } from "@dash/filters";

import { blikCheckStatusSerializer } from "@megaron/loyalty-orders-contracts";
import { Serializers, SerializerValue } from "@megaron/serializers";

export const blikChecksFiltersSerializer = Serializers.object({
  page: Serializers.integer.optional(),
  status: Serializers.jsonString(Serializers.array(blikCheckStatusSerializer)).optional(),
  searchTerm: Serializers.string.optional(),
}).partial();

export type BlikChecksFiltersType = SerializerValue<typeof blikChecksFiltersSerializer>;

export const useBlikChecksFilters = () => {
  const defaultFilters: BlikChecksFiltersType = {
    page: 0,
    status: undefined,
    searchTerm: undefined,
  };

  const { filters, setFilters } = useQsFilters(blikChecksFiltersSerializer, defaultFilters);

  const setFilter =
    <K extends keyof BlikChecksFiltersType>(key: K) =>
    (value: BlikChecksFiltersType[K]) =>
      setFilters({ ...filters, [key]: value });

  return { filters, setFilter, setFilters, defaultFilters };
};
